import {
  GET_BID_PROJECT_SPRINTS,
  GET_BID_PROJECT_SPRINTS_SUCCESS,
  GET_BID_PROJECT_SPRINTS_ERROR,
  GET_BID_PROJECT_SPRINTS_USER_STORIES,
  GET_BID_PROJECT_SPRINTS_USER_STORIES_SUCCESS,
  GET_BID_PROJECT_SPRINTS_USER_STORIES_ERROR,
  GET_STORY_DETAILS,
  GET_STORY_DETAILS_SUCCESS,
  UPDATE_EXISTING_BID_SUCCESS,
  UPDATE_EXISTING_BID
} from "../actions/constant";

const myBid = (
  state = {
    sprints: [],
    isFetching: false,
    userStories: [],
    stories: {}
  },
  action,
) => {
  switch (action.type) {
    case UPDATE_EXISTING_BID:
      return {
        ...state,
        isFetching: true
      }

    case UPDATE_EXISTING_BID_SUCCESS:
      return {
        ...state,
        isFetching: false
      }

    case GET_STORY_DETAILS:
      return {
        ...state,
        isFetching: true
      }

    case GET_STORY_DETAILS_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        stories: {
          ...state.stories,
          [[action.storyId]]: action.data
        }
      }
    }

    case GET_BID_PROJECT_SPRINTS:
      return Object.assign({}, state, {
        isFetching: true,
      });
    case GET_BID_PROJECT_SPRINTS_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        sprints: action.payload,
      });
    }
    case GET_BID_PROJECT_SPRINTS_ERROR:
      return Object.assign({}, state, {
      });
    case GET_BID_PROJECT_SPRINTS_USER_STORIES:
      return Object.assign({}, state, {
        isFetching: true,
      });
    case GET_BID_PROJECT_SPRINTS_USER_STORIES_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        userStories: action.userStories,
      });
    case GET_BID_PROJECT_SPRINTS_USER_STORIES_ERROR:
      return Object.assign({}, state, {
      });
    default:
      return state;
  }
  return state
};

export default myBid;
